module.exports = __webpack_public_path__ + "static/media/big-arrow-left.3fa04b89.svg";